import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const createBtn: SxStyle = {
  px: 1.5,
};

export const headerSubtitle: SxStyle = {
  color: (p) => p.palette.grey[500],
};
